<template>
  <div>
    <jwplayer ref="jwplayer" :options="this.$manager.jwOptions"></jwplayer>
  </div>
</template>

<script>

  import PlayerMixin from '../mixins/PlayerMixin.vue'

  export default {

    name: 'SourcePlayer',

    mixins: [PlayerMixin],

    data () {
      return {
        source: null
      }
    },

    mounted () {
        this.$nextTick(function(){
            this.setup();
        })
    },

    methods: {


      setup() {

          this.source = this.$settings.source || {
              title: '',
              description: '',
              poster: '',
              image: '',
              streamurl_hls: this.$route.query.hls || ''
          }

          this.$manager.addItemData({
              source: 'hls',
              id: this.source.streamurl_hls,
              title: this.source.titel,
              description: this.source.beschreibung,
              poster: this.source.poster,
              image: this.source.image
          })

          var adSchedule = {};

          // Preroll
          if(this.source.PREROLL && this.source.PREROLL != "") {
              adSchedule.preroll = {
                  offset: "pre",
                  tag: this.source.PREROLL
              };
          }

          // Midroll
          if(this.source.MIDROLL && this.source.MIDROLL != "") {
              adSchedule.midroll = {
                  offset: "50%",
                  tag: this.source.MIDROLL
              };
          }

          // Postroll
          if(this.source.POSTROLL && this.source.POSTROLL != "") {
              adSchedule.postroll = {
                  offset: "post",
                  tag: this.source.POSTROLL
              };
          }

          if(this.$settings.ads) {
              // Settings übernehmen
              this.$manager.addOptions('advertising', {
                  schedule: adSchedule
              })
          }

          let sourceMedia = {}

          if(this.source && this.source.streamurl_hls) {
            sourceMedia = {
              file: this.$helpers.streamToHttps(this.source.streamurl_hls),
              type: 'hls'
            }
          }
          else if (this.source && this.source.streamurl_mp4) {
            sourceMedia = {
              file: this.$helpers.streamToHttps(this.source.streamurl_mp4),
              type: 'mp4'
            }
          }
          else if (this.source && this.source.streamurl_auto) {
              sourceMedia = {
                  file: this.$helpers.streamToHttps(this.source.streamurl_auto),
              }
          }

          // Playliste übernehmen
          this.$manager.addPlaylist([{
              title: this.source.titel,
              description: this.source.beschreibung,
              image: this.source.poster,
              sources: [sourceMedia],
              starttime: this.source.starttime || null,
          }])

          // Setup fertig
          this.$manager.finalizeSetup()


      },


      demo () {

        this.$manager.addItemData({
          source: 'hls',
          title: 'RTL2 Demo Video',
          format: 'unknown',
          formatId: 'na',
          episode: false,
        })

        this.$manager.addPlaylist([{
          title: 'rtl2 demo video',
          image: '',
          sources: [{
            // file: 'http://trans_01_dach-vh.akamaihd.net/i/delivery/10/82/10826948-c10d-4cab-9789-80423a95e9ea/01SZ2D0010694WVJ_,650,1350,250,3850,2350,1000,65,k.mp4.csmil/master.m3u8',
            // file: 'http://rtl2_news_dach-vh.akamaihd.net/i/delivery/a8/34/a834ca47-d4fb-4d7f-9814-ac0a26575e27/01SZ2D0012314WVN_03_RN_175100286_,600k,2500k,1000k,1500k,400k,4000k,800k,8000k,200k,.mp4.csmil/master.m3u8',
            //   file: 'http://rtl2_news_dach-vh.akamaihd.net/i/delivery/45/06/45061627-6bcb-4873-b62a-d2e5212aaf85/01SZ2D0012316WVE_01_RN_180700286_,400k,200k,1000k,800k,2500k,4000k,8000k,1500k,600k,.mp4.csmil/master.m3u8',
              //file: 'http://rtl2_news_free-vh.akamaihd.net/i/delivery/61/78/6178b4b1-574a-4640-ac80-943dc0d6aa2b/01SZ2D0012314WVN_01_RN_165500286_,600k,1500k,200k,1000k,800k,8000k,2500k,400k,4000k,.mp4.csmil/master.m3u8',
              //file: 'http://rtl2_news_free-vh.akamaihd.net/i/delivery/20/ab/20ab0179-3958-4c27-879d-d205537928d0/01SZ2D0012314WVN_01_RN_163300286_636658006905432733_,1000k,200k,1500k,8000k,400k,800k,4000k,600k,2500k,.mp4.csmil/master.m3u8',
              // file: 'https://trans01dach-vh.akamaihd-staging.net/i/delivery/50/b1/50b1355d-e019-415d-8788-c9030ffc6436/01SZ2D0011682WVA_,65,1350,3850,250,650,1000,2350,k.mp4.csmil/master.m3u8',
              file: 'http://trans01dach-vh.akamaihd-staging.net/i/delivery/50/b1/50b1355d-e019-415d-8788-c9030ffc6436/01SZ2D0011682WVA_,65,1350,3850,250,650,1000,2350,k.mp4.csmil/master.m3u8',

            type: 'hls'
          }]
        }])

        this.$manager.finalizeSetup()
      }


    }

  }
</script>



// WEBPACK FOOTER //
// src/components/Source.vue